import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import { api, type DoctorsListParams } from '@/lib/api-client'

/** Doctor roster (Avixo #activeDoctorColumns) with computed is_floating. */
export function useDoctors(params?: DoctorsListParams) {
  return useQuery({
    queryKey: ['doctors', params],
    queryFn: () => api.doctors.list(params),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  })
}

/** Staff edit of a roster lane (active toggle / notes). */
export function useUpdateDoctor() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (args: { id: number; active?: boolean; notes?: string | null }) =>
      api.doctors.update(args.id, { active: args.active, notes: args.notes }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['doctors'] })
    },
  })
}
